import { shallowMount } from "@vue/test-utils";
import DateProposal from "@/components/core/composite/combos/DateProposal";

describe("DateProposal component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(DateProposal);
  });

  it("Renders del component DateProposal", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
